import React from 'react';
import Link from '../components/Link';
import Line from '../components/Line';
import Image from '../components/Image';
import CommissionText from '../components/CommissionText';
import {
    coral as coralUrls,
    common as commonUrls,
} from '../urlConstants';
import '../styles.scss';
import { getCurrentYear } from '../../utils/currentDate';

const Coral = () => (
    <div className="bs-gamblingCompliance">
        <div className="bs-gamblingCompliance__message">
            <Line className="bs-gamblingCompliance__line--spacer">
                Bets are accepted in accordance with the
                operator’s <Link href={coralUrls.tscs} text="terms and conditions" />
                . <Link href={coralUrls.website} text="Coral.co.uk" /> is operated
                by LC International Limited of Suite 6, Atlantic Suites, Gibraltar GX11 1AA.
            </Line>
            <Line className="bs-gamblingCompliance__line--spacer">
                For customers in Great Britain, Coral is
                licensed and regulated by the Gambling Commission under
                account number <Link href={coralUrls.gamblingCommission} text="54743" />.
            </Line>
            <Line className="bs-gamblingCompliance__line--spacer">
                For all other customers, Coral is licensed by the Government of Gibraltar
                with Licence numbers <Link href={coralUrls.gibraltar} text="010 & 012" />.
            </Line>
            <Line className="bs-gamblingCompliance__line--spacer">
			    {`Copyright © ${getCurrentYear()}`}
            </Line>
            <CommissionText />
        </div>
        <div className="bs-gamblingCompliance__images">
            <Image href={coralUrls.responsibleGambling} imageName="underageRed" />
            <Image href={commonUrls.gamaware} imageName="gamaware" />
            <Image href={commonUrls.gamcare} imageName="gamcare" />
            <Image href={commonUrls.gamtherapy} imageName="gamtherapyTransparent" />
            <Image href={commonUrls.gamstop} imageName="gamstop" />
            <Image href={commonUrls.raig} imageName="raig" />
        </div>
        <div className="bs-gamblingCompliance__message">
            Underage gambling is an offence
        </div>
    </div>
);

export default Coral;



// WEBPACK FOOTER //
// /src/js/common/gamblingCompliance/Coral/fullGamblingCompliance.jsx